import { SpaceEventsData } from "../../../passapp-sdk/types/spaceTypes";

// Escanear hace `history.push`, así que volver al inicio monta `Reservations` de cero: el
// cache evita que cada escaneo deje la lista tapada por el spinner.
// La clave lleva token y fecha porque el espacio sale del token y el día cambia a medianoche.
let cached: { key: string; data: SpaceEventsData } | null = null;

const cacheKey = (token: string, date: string) => `${token}|${date}`;

export const setCachedSpaceEvents = (token: string, date: string, data: SpaceEventsData) => {
  cached = { key: cacheKey(token, date), data };
};

export const getCachedSpaceEvents = (token: string, date: string): SpaceEventsData | null =>
  cached && cached.key === cacheKey(token, date) ? cached.data : null;
